import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Badge } from "../../components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function Payments() {
  const [clients, setClients] = useState([]);
  const [links, setLinks] = useState([]);
  const [form, setForm] = useState({ client_id: "", type: "", amount: "" });
  const [saving, setSaving] = useState(false);

  const load = () => {
    api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {});
    api.get("/admin/payment-links").then((r) => setLinks(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/admin/payment-links", { ...form, amount: Number(form.amount) });
      toast.success("Registro criado (Stripe em breve)");
      setForm({ client_id: "", type: "", amount: "" });
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-payments-page">
      <h1 className="text-2xl font-serif text-[#9B6179] mb-2">Pagamentos</h1>
      <Badge className="bg-[#C5A059] text-white mb-6" data-testid="stripe-coming-soon-badge">Integração Stripe — Em breve</Badge>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-[2px] p-6 shadow-sm border border-[#9B6179]/5">
          <p className="text-sm font-medium text-[#9B6179] mb-4">Gerar Link de Pagamento</p>
          <form onSubmit={submit} className="space-y-3">
            <div>
              <Label>Cliente</Label>
              <Select value={form.client_id} onValueChange={(v) => setForm({ ...form, client_id: v })}>
                <SelectTrigger data-testid="payment-form-client"><SelectValue placeholder="Selecione..." /></SelectTrigger>
                <SelectContent>{clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.first_name} {c.last_name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Tipo (ex: Sessão Laser, Pacote 5x)</Label><Input required value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="payment-form-type" /></div>
            <div><Label>Valor (€)</Label><Input required type="number" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} data-testid="payment-form-amount" /></div>
            <Button disabled={saving || !form.client_id} type="submit" className="w-full bg-[#090708] text-[#E8C47A] rounded-[2px] hover:bg-[#6F3F55] transition-colors" data-testid="payment-form-submit">Gerar Link (em breve)</Button>
          </form>
        </div>

        <div className="bg-white rounded-[2px] p-6 shadow-sm border border-[#9B6179]/5">
          <p className="text-sm font-medium text-[#9B6179] mb-4">Links Gerados</p>
          <div className="space-y-2">
            {links.map((l) => (
              <div key={l.id} className="flex justify-between items-center border-b border-[#9B6179]/5 py-2 text-sm" data-testid={`payment-link-${l.id}`}>
                <span>{l.client_name} — {l.type}</span>
                <div className="flex items-center gap-2"><span>{l.amount}€</span><Badge variant="outline">Em breve</Badge></div>
              </div>
            ))}
            {links.length === 0 && <p className="text-sm text-[#6F3F55]">Nenhum link gerado ainda.</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
